import { T } from '@/libs/translation';
import { type PopupOption } from '@/ui/component/cell';
import * as Sentry from '@sentry/browser';
import { makePopup } from './makePopup';

export const makeErrorPopup = (
  e?: unknown,
  data: { title?: string; message?: string; ok?: string; cancel?: string; priority?: number; code?: string } = {},
  option?: PopupOption,
) => {
  if (!data.code && !data.priority && !data.title) {
    Sentry.captureException(e, { level: 'error' });
  }

  if (process.env.NODE_ENV === 'development') {
    console.error(e);
  }

  return makePopup(
    {
      title: data.title ?? T('common.errors.title'),
      message: data.message
        ? data.message + (data.priority && data.code && data.priority >= 3 ? `<br/>CODE: ${data?.code}` : '')
        : T('common.errors.message'),
      ok: data.ok ?? T('common.ok'),
      cancel: data.cancel,
    },
    option,
  );
};
